module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAG1BMVEUAAAD8WB/8WB/8WB/8WB/8WB/8WB/8WB/8WB+nrSXcAAAACHRSTlMAiIfCe8caGWDmnKwAAAAwSURBVAjXYwCBYnMGGPBogTM1mihhpggKCka0Agk3BosOKGhGZiIUUGYbutMRHgIAmuwYtYcVnfwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/plus2.png
// module id = WRRU
// module chunks = 1